/* tslint:disable */
/* eslint-disable */
export enum FirmwareUpdateState {
  Actual = 'ACTUAL',
  Forced = 'FORCED',
  ForcedDownloading = 'FORCED_DOWNLOADING',
  ForcedActivation = 'FORCED_ACTIVATION',
  NeedFwUpdate = 'NEED_FW_UPDATE',
  NeedFwUpdateTriggered = 'NEED_FW_UPDATE_TRIGGERED',
  Downloading = 'DOWNLOADING',
  NeedFwActivation = 'NEED_FW_ACTIVATION',
  NeedFwActivationTriggered = 'NEED_FW_ACTIVATION_TRIGGERED'
}
